/**
 * QUEM SUSTENTA O PROJETO — a lista de parceiros, fora da tela.
 *
 * ── POR QUE ELA SAIU DO COMPONENTE ──────────────────────────────────────────────────────────
 *
 * Porque o que se quer cobrar aqui é de conteúdo, não de renderização: *todo parceiro diz o que
 * faz?* e *a nota do fim declara a lacuna que ainda existe?*. Para perguntar isso ao componente
 * era preciso montar a tela inteira, e a tela puxa a barra de navegação, que puxa o estado global,
 * que puxa o Firebase. Um teste de texto não deveria precisar de banco.
 *
 * ── O ACHADO QUE ESTE ARQUIVO FECHA, E A METADE DELE QUE ERA MINHA ──────────────────────────
 *
 * *"Em Parceiros, três logos são caixas vazias"* (T8.22), e o pedido: *"preencher os logos de
 * parceiros"* (T8.38). A leitura automática disso é «falta material de fora» — e foi assim que o
 * nó ficou parado desde 23/09, esperando arquivos.
 *
 * O achado tem duas metades. O **texto** dos três já estava publicado pelo próprio projeto, na
 * página «Quem somos», onde ele se apresenta: o GEOTEC é o grupo de pesquisa onde o HQ-Lab nasce,
 * o PPGEDUC é o programa de pós-graduação de onde vêm os pesquisadores, e as escolas parceiras são
 * a rede municipal, a estadual e a comunidade. Nada disso é afirmação nova sobre ninguém — é a
 * definição que o projeto dá de si mesmo, movida para a página onde o leitor foi procurá-la.
 *
 * As **marcas** continuam vindo de fora, e logo falso é pior que lacuna declarada. Por isso a nota
 * do fim encolheu em vez de sumir: ela dizia «os logos e os textos», e agora diz só as marcas.
 */

/*
 * ── 06/10/2026 · A PÁGINA PASSA A MOSTRAR SÓ OS PARCEIROS OFICIAIS COM MARCA ────────────────
 *
 * Decisão do operador, em chat: «Deixe só os parceiros oficiais que tem logos na página». As
 * marcas que existem são as que ele entregou (pasta do Drive do projeto): CAPES e Inova Educação.
 * Os cinco blocos de texto anteriores (UNEB, MVP Consultoria, GEOTEC, PPGEDUC, escolas) saíram
 * desta página por essa decisão — não por erro no texto deles.
 *
 * O que cada um FEZ no projeto não veio junto, então a página não diz. Ela mostra a marca e o nome
 * oficial, e nada que seja afirmação nova sobre uma instituição real.
 */
import logoCapes from "./assets/capes.png";
import logoInova from "./assets/inova-educacao.png";

export interface Parceiro {
  /** Como ele é chamado — é o que a professora reconhece. */
  nome: string;
  /** A marca, como o parceiro a entregou. Parceiro sem marca não entra nesta página. */
  logo: string;
  /** O nome por extenso, quando a sigla não se explica sozinha. */
  completo?: string;
}

export const PARCEIROS: Parceiro[] = [
  {
    nome: "CAPES",
    logo: logoCapes,
    completo: "Coordenação de Aperfeiçoamento de Pessoal de Nível Superior",
  },
  {
    nome: "Inova Educação",
    logo: logoInova,
  },
];

/** Palavras da nossa oficina que não entram numa página que uma professora abre (T8.22). */
export const PALAVRAS_DE_OFICINA = ["repositório", "repositorio", "commit", "deploy", "branch"];
